<template>
  <div style="text-align:center; display:flex; justify-content:center; gap:15px; flex-wrap:wrap; padding:15px 0;">
    <a 
      v-for="platform in platforms" 
      :key="platform.name"
      href="#" 
      :title="platform.name"
      style="transition:transform 0.2s;" 
      @click.prevent 
      @mouseover="$event.target.style.transform = 'scale(1.1)'" 
      @mouseleave="$event.target.style.transform = 'scale(1)'"
    >
      <img 
        :src="platform.icon" 
        :alt="platform.name"
        style="width:50px; height:50px;" 
      >
    </a>
  </div>
</template>

<script>
export default {
  name: 'SocialSharePreview',
  
  data() {
    return {
      platforms: [
        {
          name: 'Facebook',
          icon: require('@assets/images/socials/facebook.webp')
        },
        {
          name: 'X',
          icon: require('@assets/images/socials/x.webp')
        },
        {
          name: 'Threads',
          icon: require('@assets/images/socials/threads.png')
        },
        {
          name: 'LinkedIn',
          icon: require('@assets/images/socials/linkedin.webp')
        },
        {
          name: 'WhatsApp',
          icon: require('@assets/images/socials/whatsapp.png')
        },
        {
          name: 'Reddit',
          icon: require('@assets/images/socials/reddit.svg')
        },
        {
          name: 'Pinterest',
          icon: require('@assets/images/socials/PinterestFill.png')
        }
      ]
    }
  }
}
</script>

<style scoped>
/* No additional styles needed - all inline for preview consistency */
</style>

